<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="政府园区名称">
          <el-input placeholder="请输入政府园区名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item label="政商企id">
          <el-input placeholder="请输入政商企id" v-model="formInline.supply_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="info" v-if="supply_id > 0" @click="cancelFunc">返回上一页</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加政府企业/园区/土地</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="type" label="类型名称">
              <template slot-scope="scope">
                <div v-if="scope.row.type == 'enterprise'">企业</div>
                <div v-if="scope.row.type == 'park'">园区</div>
                <div v-if="scope.row.type == 'land'">土地</div>
              </template>
            </el-table-column>
            
            <!-- 添加状态列 -->
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status == 1 ? 'success' : 'info'">
                  {{ scope.row.status == 1 ? '已上架' : '未上架' }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <!-- 上下架按钮 -->
                <el-button 
                  v-if="scope.row.status == 0" 
                  @click="shelvesClick(scope.row)" 
                  type="text" 
                  size="small"
                  style="color: #67C23A">
                  上架
                </el-button>
                <el-button 
                  v-else 
                  @click="offShelvesClick(scope.row)" 
                  type="text" 
                  size="small"
                  style="color: #E6A23C">
                  下架
                </el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color: #F56C6C">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" :supply_id="supply_id" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :supply_id="supply_id" :park_id="park_id" v-if="open_edit" @close="closeEdit"></Edit>

    <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
  import ParkApi from '@/api/park.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          supply_id:0
        },
        open_add:false,
        open_edit:false,
        park_id:"",
        dialogVisible:false,
        supply_id:0
      };
    },
    created() {
      this.supply_id = this.$route.query.supply_id;
      this.formInline.supply_id = this.$route.query.supply_id;
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//政府园区标题设置
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        ParkApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
      /*添加任务*/
      addClick() {
        this.open_add = true
      },
      /*编辑活动*/
      editClick(row) {
        this.park_id = row.park_id;
        this.open_edit = true
      },
      /*上架操作*/
      shelvesClick(row) {
        let self = this;
        self.$confirm('确定要上架该项目吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ParkApi.shelves({
            park_id: row.park_id,
            status: 1
          }, true).then(data => {
            if (data.code == 1) {
              self.$message({
                message: '上架成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error(data.msg || '操作失败');
            }
          }).catch(error => {});
        }).catch(() => {});
      },
      /*下架操作*/
      offShelvesClick(row) {
        let self = this;
        self.$confirm('确定要下架该项目吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ParkApi.shelves({
            park_id: row.park_id,
            status: 0
          }, true).then(data => {
            if (data.code == 1) {
              self.$message({
                message: '下架成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error(data.msg || '操作失败');
            }
          }).catch(error => {});
        }).catch(() => {});
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ParkApi.del({
            park_id: row.park_id
          }, true).then(data => {
            if (data.code == 1) {
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error('错了哦，这是一条错误消息');
            }
          }).catch(error => {});
        }).catch(() => {});
      }
    }
  };
</script>

<style>
  /* 可以添加一些自定义样式 */
  .el-table .cell {
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/park/index.vue